import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { enqueueSnackbar } from 'actions';
import {
	Card,
	CardContent,
	TextField,
	Grid,
	Button,
	colors
} from '@mui/material';

import { RunRemoveEBandIps } from '../../actions/RemoveEBandIpsActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const RemoveEBandIps = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const user = useSelector(state => state.session.user);

	const _runRemoveEBandIps = file => {
		if (file[0].size > 10000000 || !file[0].name.includes('Cancelled Links')) {
			dispatch(
				enqueueSnackbar({
					message: `File ${file[0].name} not valid. Please check file size, type and nomenclature.`,
					options: { variant: 'warning' }
				})
			);
			return;
		}
		const username = `${user.firstname} ${user.lastname}`;
		dispatch(RunRemoveEBandIps(file[0], username, user.id));
	};

	return (
		<Page className={classes.root} title="IP Assignment">
			<Header module="IpAssignment" view="Remove E-Band IPs" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						<FilesDropzone multiple={false} acceptedTypes=".xlsx" upload={_runRemoveEBandIps} />
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default RemoveEBandIps;
